import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setAddUserSearchText } from "../../../store/profileDetail/profileDetail.reducer"

// SearchBar para filtrar lista de usuarios a seleccionar para asignar a un perfil
export const AddUserSearchBar = () => {
    const dispatch = useDispatch();
    const searchText = useSelector((state: RootState) => state.profileDetail.addUserSearchText);

    return (
        <IonSearchbar
            value={searchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setAddUserSearchText(value));
            }}
            debounce={700}
            placeholder={"Buscar usuario..."}
            autocomplete="off"
        />
    );
};